import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "A lil example doc to help pick a typescale when starting a project.", -1)
const _hoisted_4 = { class: "operations-list" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "root:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, "ratio:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "paragraph spacing:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "indent:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _hoisted_5,
        _createTextVNode(),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.f) = $event))
        }, null, 512), [
          [_vModelText, _ctx.f]
        ])
      ]),
      _createElementVNode("li", null, [
        _hoisted_6,
        _createTextVNode(),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.r) = $event))
        }, null, 512), [
          [_vModelText, _ctx.r]
        ])
      ]),
      _createElementVNode("li", null, [
        _hoisted_7,
        _createTextVNode(),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.m) = $event))
        }, null, 512), [
          [_vModelText, _ctx.m]
        ])
      ]),
      _createElementVNode("li", null, [
        _hoisted_8,
        _createTextVNode(),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.indent) = $event))
        }, null, 512), [
          [_vModelText, _ctx.indent]
        ])
      ])
    ])
  ]))
}